<template>
  <div id="bar6"></div>
</template>
<script>
import lytable from "../lytable.vue";
export default {
  components: { lytable },
  data() {
    return {
      myData: {
        xData: [
          "KM01",
          "KM02",
          "KM04",
          "KM05",
          "KM06",
          "KM07",
          "KM08",
          "KM09",
          "KM11",
          "KM12",
          "KM13",
          "KM14",
        ],
        yData: [12, 32, 15, 14, 27, 9, 7],
      },
      searchItem: {
        endTime: "",
        startTime: "",
      },

      //http://120.25.144.155:8001/gps-d?carld=3630#/login
      //http://120.25.144.155:8001/gps-d?carld=3630
    };
  },
  methods: {
    reach(v) {
      //this.searchItem.startTime = v.start;
     // this.searchItem.endTime = v.end;
      this.searchItem.startTime = v.end-86400000*365;
      this.searchItem.endTime = v.end;

      this.getData();
    },

    getData() {
      //console.log('年度修车',this.utils.time(this.searchItem.startTime))
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-dpc/board/countRefuelRank",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        console.log("看板油耗数据",data);
        //var data=[];
        /* for (let i = 0; i < 10; i++) {
          var obj={
            carNo:'陕K344'+i,
            alarmNum:30-i
          }
          data.push(obj);
        } */
        var arr = {
          xData: [],
          yData: [],
        };
        for (let i = 0; i < data.length; i++) {
          data[i].carNo=data[i].carNo.slice(0,8)
          arr.xData.push(data[i].carNo);
          arr.yData.push(data[i].amount);
        }
        this.myData=arr;
        this.draw();
      });
    },
    draw() {
      this.chart = this.echarts.init(document.getElementById("bar6"), "dark");
      this.option = {
        backgroundColor: "",
        grid: {
          x: 50,
          y: 20,
          x2: 40,
          y2: 80, //距离下边的距离
        },
        dataZoom: [
          {
            type: "inside",
            //type: "slider",
            start: 0, //放大起点
            //end: this.list.length<500?100:100/(this.list.length/500) //放大终点
            end: 100, //放大终点
          },
        ],
        xAxis: {
          type: "category",
          data: this.myData.xData,
          axisLabel: { rotate: 45, color: "#999" },
          axisLine: {
            lineStyle: {
              color: "#999",//线条颜色
            },
          },
          axisTick:{
            show:true,
            lineStyle: {
              color: "#999",//线条颜色
            },
          }
        },
        yAxis: {
          type: "value",
          axisLabel: { rotate: 0, color: "#999" },
          axisLine: {
            lineStyle: {
              color: "#999",//线条颜色
            },
          },
          axisTick:{
            show:true,
            lineStyle: {
              color: "#999",//线条颜色
            },
          }
        },
        color: "#f48d03",
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#fac73a", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#f48a00", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        series: [
          {
            data: this.myData.yData,
            type: "bar",
            label: {
              show: true,
              position: "top",
            },
            barWidth: 14,
          },
        ],
        tooltip: {
          //工具提示
          left: 20,
          formatter: function (val) {
            return val.name + "：" + val.value + "元";
          },
        },
      };
      this.chart.setOption(this.option);
      this.chart.resize();
    },
  },
};
</script>
<style>
#bar6 {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/xunchache.vue